module.exports = __webpack_public_path__ + "img/46.f6849904.png";